module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-02-aa27adc2bca64e9cab6bc59660c65518.jpg";